var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRequests = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 16H6v2h18zm-6 4v2H6v-2zm-4 4H6v2h8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4a4 4 0 1 1 5 3.874V10h11a3 3 0 0 1 3 3v9.172a3 3 0 0 1-.879 2.12l-6.828 6.83a3 3 0 0 1-2.121.878H4a3 3 0 0 1-3-3V13a3 3 0 0 1 3-3h11V7.874A4 4 0 0 1 12 4m4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m13 11v9.013a2 2 0 0 0-.207-.013H22.5a1.5 1.5 0 0 0-1.5 1.5v6.293q0 .106.013.207H4a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h11v1a1 1 0 1 0 2 0v-1h11a1 1 0 0 1 1 1m-1.414 11L23 28.586V24z",
  clipRule: "evenodd"
})));
export default SvgRequests;